import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { SpinnerStyle } from '../../../../constants/styling.constants';
import { ISettings } from '@lsq-frontend/angular-shared/settings';

/**
 * @group Basic Toolkit
 * @component Loading Indicator
 *
 */
@Component({
    selector: 'lsq-circle-loader',
    template: `
        <ng-content></ng-content>
        <div class="loader text-center">
            <div
                *ngIf="caclulatedSpinnerType === spinnerStyle.default"
                class="layout-center"
                [ngClass]="{ 'layout-center-padding': showPadding }"
            >
                <div class="spinner-background">
                    <svg
                        version="1.1"
                        id="loader-1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="60px"
                        height="60px"
                        viewBox="0 0 58 58"
                        style="enable-background:new 0 0 50 50;"
                        xml:space="preserve"
                    >
                        <circle cx="50%" cy="50%" r="25"></circle>
                    </svg>
                </div>
                <mat-progress-spinner
                    diameter="60"
                    strokeWidth="8"
                    mode="indeterminate"
                ></mat-progress-spinner>
            </div>

            <div
                *ngIf="caclulatedSpinnerType === spinnerStyle.fadingRing"
                class="layout-center fade-ring-spinner-container"
                [ngClass]="{ 'layout-center-padding': showPadding }"
            >
                <div class="fade-ring-spinner"></div>
            </div>

            <div
                *ngIf="caclulatedSpinnerType === spinnerStyle.greenRings"
                class="layout-center"
                [ngClass]="{ 'layout-center-padding': showPadding }"
            >
                <div class="ring-spinner-container">
                    <div class="spinner-ring">
                        <div class="spinner-ring">
                            <div class="spinner-ring">
                                <div class="spinner-ring">
                                    <div class="spinner-ring">
                                        <div class="spinner-ring">
                                            <div class="spinner-ring"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                *ngIf="caclulatedSpinnerType === spinnerStyle.compass"
                [ngStyle]="{ transform: getScale(), 'transform-origin': 'top' }"
                class="layout-center"
                [ngClass]="{ 'layout-center-padding': showPadding }"
            >
                <div class="compass-spinner-container">
                    <div class="compass-spinner">
                        <div class="compass-spinner-internal-details"></div>
                    </div>
                    <div class="compass-spinner-details"></div>
                </div>
            </div>

            <p class="sr-only">Loading</p>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./lsq-circle-loader.component.scss']
})
export class LsqCircleLoaderComponent {
    @Input() public showPadding = true;
    @Input() public isLarge = false;
    @Input() public spinnerType?: string;

    public spinnerStyle = SpinnerStyle;

    constructor(@Inject(SETTINGS) public settings: ISettings) {}

    public getScale(): string {
        if (this.isLarge) {
            return 'scale(1.5)';
        } else {
            return 'scale(1)';
        }
    }

    public get caclulatedSpinnerType(): string {
        if (
            this.settings.spinnerType === SpinnerStyle.greenRings ||
            (this.spinnerType && this.spinnerType === SpinnerStyle.greenRings)
        ) {
            return SpinnerStyle.greenRings;
        }

        if (
            this.settings.spinnerType === SpinnerStyle.fadingRing ||
            (this.spinnerType && this.spinnerType === SpinnerStyle.fadingRing)
        ) {
            return SpinnerStyle.fadingRing;
        }

        if (
            this.settings.spinnerType === SpinnerStyle.compass ||
            (this.spinnerType && this.spinnerType === SpinnerStyle.compass)
        ) {
            return SpinnerStyle.compass;
        }

        return SpinnerStyle.default;
    }
}
